import { GeneralPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

/** Mounted at developer/automations, for users who can manage automations; the Developer section's allowlist decides the side nav. */
export const automationsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "Automations",
      permission: GeneralPermissions.MANAGE_AUTOMATIONS,
    },
    async lazy() {
      const { AutomationsApiProvider } =
        await import("./api/automations-api-provider");
      return { Component: AutomationsApiProvider };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AutomationsPage } = await import("./list/automations-page");
          return { Component: AutomationsPage };
        },
      },
      {
        // One route for the editor and its runs, so moving between them keeps the editor open.
        path: ":automationId/*",
        handle: { breadcrumb: "Automation" },
        async lazy() {
          const { AutomationEditorPage } = await import("./editor/editor-page");
          return { Component: AutomationEditorPage };
        },
      },
    ],
  },
];
